import React, { Component } from 'react';
import { connect } from 'react-redux';

class ChannelListDesktop extends Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div class="channel-list-desktop">

            </div>
        )
    }
}

export default ChannelListDesktop;


// WEBPACK FOOTER //
// ./src/channelListDesktop.js